module.exports = __webpack_public_path__ + "img/cashAPP.df59036c.png";